import NearMissHeader from "./components/NewNearMissHeader";

export default NearMissHeader;